class Accordion {
    constructor() {
        this.containers = [];
        this.init();
        this.accordionListeners();
        this.inProgress = false;
    }

    /**
     * Инициализация аккордионов при создании или изменении
     */
    init() {
        this.collectContainers();
        this.containerListeners();
        this.setInitialized();
    }

    /**
     * Сбор всех аккордионов на странице
     */
    collectContainers() {
        const containers = document.querySelectorAll('[data-accordion-container]:not([data-initialized="true"])');
        containers.forEach((containerElement) => {
            this.containers.push(new AccordionContainer(containerElement));
        });
    }

    /**
     * Отслеживание менеджером изменений и ресайза
     */
    accordionListeners() {
        const instance = this;

        document.addEventListener('DOMContentMutated', () => {
            // Переинициализация текущих контейнеров для отслеживания в них новых элементов
            instance.containers.forEach(container => container.init());

            // Переинициализация менеджера для отслеживания новых контейнеров
            instance.init();
        })

        document.addEventListener('NeedInitAccordion', () => {
            instance.init();
        });

        window.addEventListener('resize', () => {
            // Передача ресайза контенерам
            instance.containers.forEach(container => container.onResize());
        });
    }

    /**
     * Помечаем контейнеры как обработанные
     */
    setInitialized() {
        this.getNotInitContainers().forEach(container => container.containerElement.dataset.initialized = "true");
    }

    /**
     * Взять все не аккордионы, не помеченные как обработанные
     */
    getNotInitContainers() {
        return this.containers.filter(container => !container.containerElement.dataset.initialized);
    }

    /**
     * (Редкая потребность)
     * Слушатели
     * - слушатели елементов контейнера на открытие и закрытие элементов для передачи события на документ
     */
    containerListeners() {
        const instance = this;
        this.getNotInitContainers().forEach((container) => {
            instance.transferEvent(container, 'ContainerElementOpen', 'AccordionOpen');
            instance.transferEvent(container, 'ContainerElementClose', 'AccordionClose');
        });
    }

    /**
     * Отследить событие listenEvent у container и отправить dispatchEvent на документ
     */
    transferEvent(container, listenEvent, dispatchEvent) {
        container.containerElement.addEventListener(listenEvent, (e) => {
            const eventElement = e.detail.element;
            document.dispatchEvent(new CustomEvent(dispatchEvent, {
                detail: {
                    container: container.containerElement,
                    element: eventElement
                }
            }))
        });
    }
}

class AccordionContainer {
    modes = [
        'single',
        'multi'
    ];
    constructor(containerElement) {
        this.containerElement = containerElement;

        this.elements = [];

        const mode = this.containerElement.dataset.accordionMode;
        if (mode && this.modes.includes(mode)) {
            this.mode = mode;
        } else {
            this.mode = 'single';
        }

        this.init();
    }

    /**
     * Инициализация аккордиона при создании или изменении
     */
    init() {
        this.collect();
        this.elementListeners();
        this.setInitialized();
    }

    /**
     * Сбор всех элементов аккордиона
     */
    collect() {
        const elements = this.containerElement.querySelectorAll('[data-accordion-element]:not([data-initialized="true"])');
        elements.forEach((element) => {
            try {
                this.elements.push(new AccordionElement(element));
            } catch (e) {
                console.log(e);
            }
        });
    }

    /**
     * Прослушка элементов
     */
    elementListeners() {
        this.getNotInitContainers().forEach((currentElement) => {
            this.listenOpen(currentElement.element);
            this.listenClose(currentElement.element);
        });
    }

    /**
     * Прослушка события ElementOpen у элемента (событие отправляется только при клике по ссылке внутри элемента)
     */
    listenOpen(currentElement) {
        const instance = this;
        currentElement.addEventListener('ElementOpen', (e) => {
            if (instance.mode === 'single') {

                // Сворачиваем прочие элементы
                instance.elements
                    .filter((element) => element.isOpened && element.element !== currentElement)
                    .forEach((element) => {
                        element.close();
                    });
            }

            // Отправляем событие на контейнер
            instance.containerElement.dispatchEvent(new CustomEvent('ContainerElementOpen', {
                detail: {
                    element: currentElement
                }
            }));
        });
    }

    /**
     * Прослушка события ElementOpen у элемента (событие отправляется только при клике по ссылке внутри элемента)
     */
    listenClose(currentElement) {
        const instance = this;
        currentElement.addEventListener('ElementOpen', (e) => {
            // Отправляем событие на контейнер
            instance.containerElement.dispatchEvent(new CustomEvent('ContainerElementClose', {
                detail: {
                    element: currentElement
                }
            }));
        });
    }

    /**
     * Помечаем элементы как обработанные
     */
    setInitialized() {
        this.getNotInitContainers().forEach(object => object.element.dataset.initialized = "true");
    }

    /**
     * Отправляем ресайз на элементы
     */
    onResize() {
        this.elements.forEach(element => element.onResize());
    }

    /**
     * Хватаем все элементы, которые не помечены как обработанные
     */
    getNotInitContainers() {
        return this.elements.filter(object => !object.element.dataset.initialized);
    }
}

class AccordionElement {
    constructor(element) {
        this.element = element;

        this.link = this.element.querySelector('[data-accordion-link]');
        this.block = this.element.querySelector('[data-accordion-block]');

        if (this.link.dataset.accordionLinkText) {
            this.textLinkElement = this.link.dataset.accordionLinkText;
        } else {
            this.textLinkElement = this.link.querySelector('[data-accordion-link-text]');
        }

        if (!this.link) {
            throw new Error('Element by selector [data-accordion-link] not found');
        }
        if (!this.block) {
            throw new Error('Element by selector [data-accordion-block] not found');
        }

        if (this.block.childElementCount !== 1) {
            throw new Error('Element by selector [data-accordion-block] must contain 1 child');
        }

        // this.block.style.overflow = 'hidden';
        this.content = this.block.children[0];
        this.defineHeight();
        this.addListeners();

        if (!!this.element.dataset.isOpened) {
            this.setOpenedProperties();
        } else {
            this.setCloseProperties();
        }

        this.checkHeightListener()
    }

    /**
     * Установка целевой высоты равной высоте контента блока
     */
    defineHeight() {
        this.targetHeight = this.content.clientHeight;
    }

    /**
     * Развернуть и отправить событие
     */
    open() {
        this.setOpenedProperties();
        this.element.dispatchEvent(new CustomEvent('ElementOpen'));
    }

    /**
     * Свернуть и отправить событие
     */
    close() {
        this.setCloseProperties();
        this.element.dispatchEvent(new CustomEvent('ElementClose'));
    }

    /**
     * Развернуть
     */
    setOpenedProperties() {
        this.block.style.height = `${this.targetHeight}px`;
        this.isOpened = true;
        this.element.classList.add('_opened');
        this.swipeText();
    }

    /**
     * Свернуть
     */
    setCloseProperties() {
        this.block.style.height = '';
        this.isOpened = false;
        this.element.classList.remove('_opened');
        this.swipeText();
    }

    /**
     * Подменить текст при наличии
     */
    swipeText() {
        if (this.textLinkElement) {
            const text = this.textLinkElement.dataset.accordionLinkText;
            this.textLinkElement.dataset.accordionLinkText = this.textLinkElement.innerHTML;
            this.textLinkElement.innerHTML = text;
        }
    }

    /**
     * Отслеживание нажатия по переключателю
     */
    addListeners() {
        const instance = this;
        this.link.addEventListener('click', (e) => {
            e.preventDefault();
            if (instance.isOpened) {
                instance.close();
            } else {
                instance.open();
            }
        });
    }

    onResize() {
        this.defineHeight();
        if (this.isOpened) {
            this.setOpenedProperties();
        }
    }

    checkHeightListener() {
        this.element.addEventListener('checkHeight', () => {
            this.onResize();
        });
    }
}

document.addEventListener('DOMContentLoaded', () => {
    new Accordion();
})